export const PATH_MAPPA = "/";
export const PATH_ELENCO = "/elenco";
export const PATH_DASHBOARD = "/dashboard";
export const PATH_DETTAGLIO = "/dettaglio";
export const PATH_INFO = "/info";
export const PATH_INFO_CODICI_COLORE = "/info/codiciColore";
export const PATH_INFO_GRADO_AFFOLLAMENTO = "/info/gradoAffollamento";
export const PATH_INFO_PRIVACY_POLICY = "/info/privacyPolicy";
